module.exports = __webpack_public_path__ + "static/media/rightarrow1.07d480e1.svg";